import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgRewind = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.626 3.504a1.307 1.307 0 0 1 1.428-.078c.221.127.397.313.517.53.119.216.179.459.179.702v14.684M19.626 3.504l-5.076 3.46V4.657c0-.243-.06-.486-.18-.702a1.4 1.4 0 0 0-.516-.53 1.31 1.31 0 0 0-1.445.091l-.005.003-9.595 7.34-.003.001a1.4 1.4 0 0 0-.413.508 1.46 1.46 0 0 0 0 1.262c.094.197.234.373.413.508l.003.002 9.6 7.342a1.306 1.306 0 0 0 1.445.091c.221-.128.397-.314.517-.53.119-.216.179-.459.179-.702v-2.305l5.076 3.459a1.307 1.307 0 0 0 1.428.078c.221-.128.397-.314.517-.53.119-.216.179-.459.179-.702m-1.5-14.448-6.028 4.108a.75.75 0 0 1-1.172-.62V4.915L3.786 12l9.264 7.085v-3.467a.75.75 0 0 1 1.172-.62l6.028 4.108z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgRewind;
